var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpaceshipIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62 62",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".spaceship_icon_svg__a{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-svg-primary": "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "spaceship_icon_svg__a",
    d: "M61 1L1 23.988l17.454 7.026 12.532 12.532L38.012 61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "spaceship_icon_svg__a",
    d: "M28.103 51.555L10.439 33.897l8.01-2.883 12.537 12.532zM55.234 16.095l-6.578-2.751-2.74-6.567M45.617 23.242l-4.838-2.022-2.016-4.832M41.459 29.015l-5.971-2.5-2.491-5.973M37.305 34.781l-7.109-2.977-2.966-7.109M18.454 31.014l28.893-20.812M30.986 43.546l20.817-28.887M14.427 43.088L3.11 54.4M18.912 47.573l-7.86 7.86M2.182 35.907a3.7 3.7 0 000 5.225 3.7 3.7 0 005.225 0l2.53-2.53M27.76 58.15a3.69 3.69 0 01-5.225 0 3.69 3.69 0 01.006-5.231l.867-.867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.265 8.258a.939.939 0 10-.666-.277.945.945 0 00.666.277M30.826 3.209a.944.944 0 10-.939-.944.944.944 0 00.939.944M11.953 5.744a.944.944 0 10-.872-.942.944.944 0 00.872.942M5.684 15.797a.944.944 0 10-.95-.944.944.944 0 00.95.944M58.597 31.611a.943.943 0 10-1.657-.9.943.943 0 001.657.9M59.918 16.278a.939.939 0 10.376 1.276.939.939 0 00-.376-1.276M59.398 40.315a.939.939 0 10.456.559.939.939 0 00-.456-.559M53.919 53.14a.943.943 0 10-.9 1.657.943.943 0 10.9-1.657M50.157 48.114a.944.944 0 10-.967 1.618l.066.039a.944.944 0 00.9-1.657"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpaceshipIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/spaceship_icon.b4a3d709c2e96b60a7df83a142ca56cc.svg";